import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { productImageUrl } from "../common/imageUtils";
import type { FlyingProductAnimationState } from "../common/types/productTypes";

import uiStore from "../stores/uiStore";

type FlyingProductProps = {
   plane: FlyingProductAnimationState;
};

const FlyingProduct = ({ plane }: FlyingProductProps) => {
   useEffect(() => {
      setTimeout(() => {
         uiStore.takeOff(plane.animationId);
      }, 200);
   }, []);

   return (
      <img
         alt="Produkt på vei til handlekurven"
         src={productImageUrl(plane.sku, plane.sourceWidth)}
         className="dsp-flyer"
         style={{
            top: plane.y,
            left: plane.x,
            height: plane.height
         }}
      />
   );
};

export default observer(FlyingProduct);
